import React from "react"
import { Card, CardBody, DropdownToggle, DropdownMenu, DropdownItem, Table, UncontrolledDropdown } from "reactstrap"

import FeatherIcon from "feather-icons-react"
//Simple bar
import SimpleBar from "simplebar-react"

//Import Image
import avatar1 from "../../assets/images/users/avatar-1.jpg"
import avatar2 from "../../assets/images/users/avatar-2.jpg"
import avatar4 from "../../assets/images/users/avatar-4.jpg"
import avatar5 from "../../assets/images/users/avatar-5.jpg"
import avatar6 from "../../assets/images/users/avatar-6.jpg"
import avatar7 from "../../assets/images/users/avatar-7.jpg"
import avatar8 from "../../assets/images/users/avatar-8.jpg"

const TopUser = () => {
    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <div className="float-end">
                        <UncontrolledDropdown>
                            <DropdownToggle tag="a" className="text-reset" id="dropdownMenuButton5" caret>
                                <span className="text-muted">All Members<i className="mdi mdi-chevron-down ms-1"></i></span>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                                <DropdownItem href="#">Locations</DropdownItem>
                                <DropdownItem href="#">Revenue</DropdownItem>
                                <DropdownItem href="#">Join Date</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                    <h4 className="card-title mb-4">Top Users</h4>
                    <SimpleBar style={{ maxHeight: "336px" }}>
                        <div className="table-responsive">
                            <Table className="table-borderless table-centered table-nowrap">
                                <tbody>
                                    <tr>
                                        <td>
                                            <h6 className="font-size-15 mb-1 fw-normal">Abdul Rahman</h6>
                                            <p className="text-muted font-size-13 mb-0">
                                                <i className="mdi mdi-map-marker"></i> Dhaka</p>
                                        </td>
                                        <td><span className="badge bg-danger text-white font-size-12">Cancel</span></td>
                                        <td className="text-muted fw-semibold text-end">
                                            <FeatherIcon icon="trending-up" className="icon-xs icon me-2 text-success" />৳250.00
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h6 className="font-size-15 mb-1 fw-normal">Fatima Begum</h6>
                                            <p className="text-muted font-size-13 mb-0"><i className="mdi mdi-map-marker"></i> Chittagong</p>
                                        </td>
                                        <td><span className="badge bg-success text-white font-size-12">Success</span></td>
                                        <td className="text-muted fw-semibold text-end">
                                            <FeatherIcon icon="trending-down" className="icon-xs icon me-2 text-danger" />৳110.00
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h6 className="font-size-15 mb-1 fw-normal">Mohammad Ali</h6>
                                            <p className="text-muted font-size-13 mb-0"><i className="mdi mdi-map-marker"></i> Sylhet</p>
                                        </td>
                                        <td><span className="badge bg-info text-white">Active</span></td>
                                        <td className="text-muted fw-semibold text-end">
                                            <FeatherIcon icon="trending-up" className="icon-xs icon me-2 text-success" />৳420.00
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h6 className="font-size-15 mb-1 fw-normal">Ayesha Akter</h6>
                                            <p className="text-muted font-size-13 mb-0"><i className="mdi mdi-map-marker"></i> Rajshahi</p>
                                        </td>
                                        <td><span className="badge bg-warning-subtle font-size-12 text-warning">Pending</span></td>
                                        <td className="text-muted fw-semibold text-end">
                                            <FeatherIcon icon="trending-down" className="icon-xs icon me-2 text-danger" />৳120.00
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h6 className="font-size-15 mb-1 fw-normal">Kamal Hossain</h6>
                                            <p className="text-muted font-size-13 mb-0"><i className="mdi mdi-map-marker"></i> Khulna</p>
                                        </td>
                                        <td><span className="badge bg-info text-white">Active</span></td>
                                        <td className="text-muted fw-semibold text-end">
                                            <FeatherIcon icon="trending-up" className="icon-xs icon me-2 text-success" />৳112.00
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h6 className="font-size-15 mb-1 fw-normal">Nusrat Jahan</h6>
                                            <p className="text-muted font-size-13 mb-0"><i className="mdi mdi-map-marker"></i> Barisal</p>
                                        </td>
                                        <td><span className="badge bg-success text-white font-size-12">Success</span></td>
                                        <td className="text-muted fw-semibold text-end">
                                            <FeatherIcon icon="trending-down" className="icon-xs icon me-2 text-danger" />৳120.00
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h6 className="font-size-15 mb-1 fw-normal">Rafiqul Islam</h6>
                                            <p className="text-muted font-size-13 mb-0"><i className="mdi mdi-map-marker"></i> Rangpur</p>
                                        </td>
                                        <td><span className="badge bg-danger text-white font-size-12">Cancel</span></td>
                                        <td className="text-muted fw-semibold text-end">
                                            <FeatherIcon icon="trending-up" className="icon-xs icon me-2 text-success" />৳112.00
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </SimpleBar>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default TopUser